import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import httpClient from '../api/axios';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  MapPin,
  Truck,
  CreditCard,
  Phone,
  User,
  MapPinned,
  Mail,
} from 'lucide-react';

const Cart = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isCartLoading, setIsCartLoading] = useState(true);

  const [allOrders, setAllOrders] = useState([]);
  const [showOrders, setShowOrders] = useState(false);
  const [error, setError] = useState(null);

  const location = useLocation();

  const { productId, quantity } = useParams();

  const [item, setitem] = useState({});

  const userId = useSelector((state) => state.auth.userId);
  const formData = useSelector((state) => state.auth.userDetails);

  useEffect(() => {
    getProductById();
  }, []);

  const getProductById = async () => {
    try {
      const res = await httpClient.get(`/api/products/${productId}`);
      setitem({
        id: res.data._id,
        name: res.data.name,
        productImg: res.data.productImg,
        pricePerKg: res.data.pricePerKg,
        quantityKg: Number(quantity),
      });
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Function to fetch all orders
  const fetchAllOrders = async () => {
    try {
      // setIsLoading(true);
      setError(null);
      const response = await httpClient.get('/api/orders');
      console.log('Fetched orders:', response.data);
      setAllOrders(response.data);
      setShowOrders(true);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      // setIsLoading(false);
    }
  };

  const handleQuantityIncrease = () => {
    if (item.quantityKg < 10) {
      setitem((prev) => ({
        ...prev,
        quantityKg: prev.quantityKg + 1,
      }));
    }
  };

  const handleQuantityDecrease = () => {
    if (item.quantityKg > 1) {
      setitem((prev) => ({
        ...prev,
        quantityKg: prev.quantityKg - 1,
      }));
    }
  };

  useEffect(() => {
    console.log(item);
  }, [item]);

  const handlePlaceOrder = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // Format order items according to the expected API format
      const orderItems = {
        productId: item.id || '',
        quantityKg: item.quantityKg,
        pricePerKg: item.pricePerKg,
      };

      const orderData = {
        userId: userId,
        items: [orderItems],
        deliveryAddress: formData?.address,
        contactNumber: formData?.phone,
      };

      console.log('Sending order data:', orderData);

      // Send order to server
      const response = await httpClient.post('api/orders', orderData);
      console.log('Order placed successfully:', response.data);

      // Show success message with order ID
      alert(
        `Order placed successfully! Order ID: ${response.data._id}`
      );

      navigate('/myorders');
    } catch (error) {
      console.error('Error placing order:', error);

      let errorMessage = 'Failed to place order. Please try again.';
      if (error.response) {
        console.error('Error response data:', error.response.data);
        errorMessage = `Error (${error.response.status}): ${
          error.response.data.message || 'Unknown error'
        }`;
      }

      setError(errorMessage);
      alert(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8 max-w-6xl'>
      {error && (
        <div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4'>
          {error}
        </div>
      )}

      <h1 className='text-3xl font-bold mb-8 text-center border-b pb-4 pt-[100px]'>
        Complete Your Order
      </h1>

      <div className='grid md:grid-cols-3 gap-4 lg:gap-8'>
        {/* Left column - Cart Items */}
        <div className='md:col-span-2'>
          <div className='bg-white rounded-lg shadow-lg overflow-hidden mb-6'>
            <div className='p-4 bg-blue-600 text-white flex items-center'>
              <CreditCard size={20} className='mr-2' />
              <h2 className='text-xl font-semibold'>Your Cart</h2>
            </div>

            {/* Mobile-friendly table approach */}
            <div className='overflow-x-auto'>
              <table className='w-full'>
                <thead className='bg-gray-100'>
                  <tr>
                    <th className='py-4 px-4 md:px-6 text-left'>
                      Product
                    </th>
                    <th className='py-4 px-2 md:px-6 text-left'>
                      Price
                    </th>
                    <th className='py-4 px-2 md:px-6 text-left'>
                      Quantity
                    </th>
                    <th className='py-4 px-2 md:px-6 text-left'>
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className='divide-y divide-gray-200'>
                  <tr key={item?.id}>
                    <td className='py-4 px-2 md:px-6'>
                      <div className='flex items-center'>
                        <img
                          src={item?.productImg}
                          alt={item?.name}
                          className='w-12 h-12 md:w-16 md:h-16 object-cover rounded mr-2 md:mr-4'
                        />
                        <div>
                          <div className='font-medium text-sm md:text-base'>
                            {item?.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className='py-4 px-2 md:px-6 text-sm md:text-base'>
                      Rs.{item?.pricePerKg}
                    </td>
                    <td className='py-4 px-2 md:px-6'>
                      <div className='flex items-center'>
                        <button
                          onClick={handleQuantityDecrease}
                          className='bg-gray-200 hover:bg-gray-300 px-2 md:px-3 py-1 rounded-l transition'
                        >
                          -
                        </button>
                        <input
                          type='number'
                          value={item?.quantityKg}
                          min='1'
                          className='w-8 md:w-12 text-center border-t border-b border-gray-300 py-1'
                          readOnly
                        />
                        <button
                          onClick={handleQuantityIncrease}
                          className='bg-gray-200 hover:bg-gray-300 px-2 md:px-3 py-1 rounded-r transition'
                        >
                          +
                        </button>
                      </div>
                    </td>
                    <td className='py-4 px-2 md:px-6 font-medium text-sm md:text-base'>
                      Rs.
                      {(item?.pricePerKg * item?.quantityKg).toFixed(
                        2
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Shipping & Contact Information */}
          <div className='bg-white rounded-lg shadow-lg overflow-hidden mb-6'>
            <div className='p-4 bg-blue-600 text-white flex items-center'>
              <MapPin size={20} className='mr-2' />
              <h2 className='text-xl font-semibold'>
                Contact & Delivery Information
              </h2>
            </div>

            <div className='p-4 md:p-6'>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                <div>
                  <label className='block text-gray-700 text-sm font-medium mb-2 flex items-center'>
                    <User size={16} className='mr-1' /> Full Name
                  </label>
                  <input
                    type='text'
                    name='name'
                    value={formData?.name}
                    className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                    placeholder='John Doe'
                    disabled
                  />
                </div>

                <div>
                  <label className='block text-gray-700 text-sm font-medium mb-2 flex items-center'>
                    <Phone size={16} className='mr-1' /> Phone Number
                  </label>
                  <input
                    type='tel'
                    name='phone'
                    value={formData?.phone}
                    className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                    placeholder='(123) 456-7890'
                    disabled
                  />
                </div>
              </div>

              <div className='mb-4'>
                <label className='block text-gray-700 text-sm font-medium mb-2 flex items-center'>
                  <Mail size={16} className='mr-1' /> Email Address
                </label>
                <input
                  type='email'
                  name='email'
                  value={formData?.email}
                  className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                  placeholder='your@email.com'
                  disabled
                />
              </div>

              <div className='mb-4'>
                <label className='block text-gray-700 text-sm font-medium mb-2 flex items-center'>
                  <MapPinned size={16} className='mr-1' /> Street
                  Address
                </label>
                <input
                  type='text'
                  name='address'
                  value={formData?.address}
                  className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                  placeholder='123 Main St'
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        {/* Right column - Order Summary */}
        <div>
          <div className='bg-white rounded-lg shadow-lg overflow-hidden sticky top-4'>
            <div className='p-4 bg-blue-600 text-white flex items-center'>
              <Truck size={20} className='mr-2' />
              <h2 className='text-xl font-semibold'>Order Summary</h2>
            </div>

            <div className='p-4 md:p-6'>
              <div className='flex justify-between mb-4'>
                <span className='text-gray-600'>Quantity:</span>
                <span className='font-medium'>
                  {item?.quantityKg}
                </span>
              </div>

              <div className='flex justify-between mb-4'>
                <span className='text-gray-600'>
                  Shipping/Delivery:
                </span>
                <span className='font-medium'>
                  To be calculated later
                </span>
              </div>

              <div className='border-t pt-4 mt-2'>
                <div className='flex justify-between text-xl font-bold'>
                  <span>Total:</span>
                  <span>Rs.{item.quantityKg * item.pricePerKg}</span>
                </div>
                <p className='text-gray-500 text-xs mt-1'>
                  Delivery Charges will be applied.
                </p>
              </div>

              <button
                onClick={handlePlaceOrder}
                disabled={isLoading}
                className={`mt-6 w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition flex items-center justify-center ${
                  isLoading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {isLoading ? 'Processing...' : 'Place Order'}
              </button>

              <div className='mt-4 text-center text-sm text-gray-500'>
                <p>Cash on Delivery</p>
                <div className='flex flex-wrap justify-center mt-2 gap-2'>
                  <span className='bg-gray-200 px-2 py-1 rounded text-xs'>
                    Phone Pe
                  </span>
                  <span className='bg-gray-200 px-2 py-1 rounded text-xs'>
                    Google Pay
                  </span>
                  <span className='bg-gray-200 px-2 py-1 rounded text-xs'>
                    PayTM
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
